import { useCallback } from "react";

import { createFileRoute, useRouter } from "@tanstack/react-router";

import { Route as OrderRoute } from "@app/navigation/routes/_private/orders/$id";
import { exchangePairsQueryOptions } from "@entities/exchange-pairs/hooks/use-exchange-pairs.ts";
import { BuyOrderPageConnector } from "@pages/buy-order/buy-order-page-connector.tsx";

export const Route = createFileRoute("/_private/buy")({
  component: RouteComponent,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(
      exchangePairsQueryOptions({
        params: { buyStatus: "ACTIVE", type: "CRYPTO_FIAT" },
      }),
    );
  },
});

function RouteComponent() {
  const { history, navigate } = useRouter();
  const onGoOrder = useCallback(
    (id: string) => {
      navigate({
        params: {
          id,
        },
        to: OrderRoute.fullPath,
      });
    },
    [navigate],
  );
  return (
    <BuyOrderPageConnector onGoBack={history.back} onGoOrder={onGoOrder} />
  );
}
